import React from 'react';
import DsModal from '../../common/DsModal';
import EventImageGallery from '../../common/events/EventImageGallery';
import EventMaterialExplorer from '../../common/events/EventMaterialExplorer';
import ChatSidePanelToggleButton from '../../common/chat/sidepanel/ChatSidePanelToggleButton';
import ChatSidePanelHeader from '../../common/chat/sidepanel/ChatSidePanelHeader';
import EventInfoSidePanelCard from '../../common/chat/sidepanel/EventInfoSidePanelCard';
import EventParticipantsSidePanelCard from '../../common/chat/members/EventParticipantsSidePanelCard';
import ChatTargetSearchModal from '../../common/chat/search/ChatTargetSearchModal';
import ChatSearchDatePresets from '../../common/chat/search/ChatSearchDatePresets';

export function ArtistEventChatSearchModal({
  isOpen,
  onClose,
  onApply,
  onClear,
  summary,
  applying,
  errorMessage,
  onRetry,
  retrying,
  searchDraft,
  setSearchDraft,
}) {
  return (
    <ChatTargetSearchModal
      isOpen={isOpen}
      title="イベントチャット検索"
      onClose={onClose}
      onApply={onApply}
      onClear={onClear}
      summary={summary}
      applying={applying}
      errorMessage={errorMessage}
      onRetry={onRetry}
      retrying={retrying}
    >
      <div className="chat-target-search-form">
        <div className="chat-target-search-form__field">
          <label className="chat-target-search-form__label" htmlFor="artist-event-search-query">
            イベント名 / 公演名
          </label>
          <input
            id="artist-event-search-query"
            className="chat-target-search-form__input"
            type="text"
            value={searchDraft.eventQuery}
            onChange={(event) =>
              setSearchDraft((current) => ({ ...current, eventQuery: event.target.value }))
            }
            placeholder="イベント名 / 公演名"
          />
        </div>

        <div className="chat-target-search-form__field">
          <label className="chat-target-search-form__label" htmlFor="artist-event-search-message">
            チャット本文
          </label>
          <input
            id="artist-event-search-message"
            className="chat-target-search-form__input"
            type="text"
            value={searchDraft.messageQuery}
            onChange={(event) =>
              setSearchDraft((current) => ({ ...current, messageQuery: event.target.value }))
            }
            placeholder="本文キーワード"
          />
        </div>

        <div className="chat-target-search-form__field">
          <span className="chat-target-search-form__label">公演日クイック指定</span>
          <ChatSearchDatePresets
            startDate={searchDraft.startDate}
            endDate={searchDraft.endDate}
            onSelect={({ startDate, endDate }) =>
              setSearchDraft((current) => ({ ...current, startDate, endDate }))
            }
          />
        </div>

        <div className="chat-target-search-form__field">
          <label className="chat-target-search-form__label" htmlFor="artist-event-search-start-date">
            公演日（開始）
          </label>
          <input
            id="artist-event-search-start-date"
            className="chat-target-search-form__input"
            type="date"
            value={searchDraft.startDate}
            onChange={(event) =>
              setSearchDraft((current) => ({ ...current, startDate: event.target.value }))
            }
          />
        </div>

        <div className="chat-target-search-form__field">
          <label className="chat-target-search-form__label" htmlFor="artist-event-search-end-date">
            公演日（終了）
          </label>
          <input
            id="artist-event-search-end-date"
            className="chat-target-search-form__input"
            type="date"
            value={searchDraft.endDate}
            onChange={(event) =>
              setSearchDraft((current) => ({ ...current, endDate: event.target.value }))
            }
          />
        </div>
      </div>
    </ChatTargetSearchModal>
  );
}

export function ArtistEventMaterialsModal({ isOpen, eventId, canUpload, onClose }) {
  if (!isOpen || !eventId) return null;

  return (
    <DsModal
      open={isOpen}
      onClose={onClose}
      title="公開資料"
      size="lg"
      className="event-material-chat-modal"
    >
      <EventMaterialExplorer
        eventUuid={eventId}
        role="artist"
        title="資料"
        canView
        canUpload={canUpload}
        canManage={false}
        canDownload
        showTitle={false}
        emptyLabel="共有資料はまだありません"
      />
    </DsModal>
  );
}

export function ArtistEventAlbumModal({ isOpen, eventId, eventName, eventDateLabel, onClose }) {
  if (!isOpen || !eventId) return null;

  return (
    <DsModal
      open={isOpen}
      onClose={onClose}
      title="イベントアルバム"
      size="lg"
      className="event-material-chat-modal event-album-chat-modal"
    >
      <EventImageGallery
        eventUuid={eventId}
        eventName={eventName}
        eventDateLabel={eventDateLabel}
        canView
        canUpload={false}
        canDownload
        showTitle={false}
      />
    </DsModal>
  );
}

export function ArtistEventChatSidePanel({
  isVisible,
  isOpen,
  onCollapse,
  onExpand,
  eventInfoProps,
  participantsPanelProps,
}) {
  if (!isVisible) return null;

  return (
    <aside
      className={`chat-side-panel side-panel artist-event-chat-side-panel${
        isOpen ? '' : ' chat-side-panel--collapsed'
      }`}
    >
      {isOpen ? (
        <>
          <ChatSidePanelHeader
            icon="fa-calendar-days"
            label="イベント情報"
            onCollapse={onCollapse}
          />
          <EventInfoSidePanelCard {...eventInfoProps} />

          <EventParticipantsSidePanelCard {...participantsPanelProps} />
        </>
      ) : (
        <div className="chat-side-panel__collapsed-rail">
          <ChatSidePanelToggleButton
            isOpen={false}
            onToggle={onExpand}
            label="イベント情報"
            iconOnly
            className="chat-side-panel__collapsed-toggle"
          />
        </div>
      )}
    </aside>
  );
}
